<template>
    <div class="product" style="height: 100%; width: 100%; position: absolute;">
        <div class="vue-padding radius" style="height: 96%; width: 98%;">
            <iframe src="https://doc.chuanyisoft.com/?g=Doc&m=Article&a=index&id=7" frameborder="0" style="width: 100%; height: 100%;"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Documents",
        components: {},
        data()  {
            return {
                
            }
        },
        mounted() {
            
        },
        methods: {
           
        }
    }
</script>
